export const aeExportOrgs = [
  "28533a29-b310-461e-9777-50c3bb55021f",
  "734712d8-8a4c-47eb-abe0-7be71db8a5fd",
  "8c7396e7-9a5a-4fcb-824d-b1b60eb48914",
  "85726493-4fe5-44e5-879e-a05a5fafab09",
  "c37fb869-eaf6-4e82-b568-c7578a688e45",
  "67ff157d-87bd-4b52-9702-3d5bc286e9dc"
]

export const pdfImportOrgs = [
  "734712d8-8a4c-47eb-abe0-7be71db8a5fd",
  "8c7396e7-9a5a-4fcb-824d-b1b60eb48914",
  "28dd213c-9012-4019-9477-fe0278db6208",
  "c37fb869-eaf6-4e82-b568-c7578a688e45",
  "85726493-4fe5-44e5-879e-a05a5fafab09",
  "67ff157d-87bd-4b52-9702-3d5bc286e9dc"
]
